/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSubcategoryLookupDto,
  SubcategoryLookupResponseDto,
  UpdateSubcategoryLookupDto,
  ValidateCodeResponseDto,
} from '../models/index';
import {
    CreateSubcategoryLookupDtoFromJSON,
    CreateSubcategoryLookupDtoToJSON,
    SubcategoryLookupResponseDtoFromJSON,
    SubcategoryLookupResponseDtoToJSON,
    UpdateSubcategoryLookupDtoFromJSON,
    UpdateSubcategoryLookupDtoToJSON,
    ValidateCodeResponseDtoFromJSON,
    ValidateCodeResponseDtoToJSON,
} from '../models/index';

export interface CreateSubcategoryRequest {
    createSubcategoryLookupDto: CreateSubcategoryLookupDto;
}

export interface DeleteSubcategoryRequest {
    id: number;
}

export interface GetAllSubcategoriesRequest {
    isActive?: boolean;
    categoryLookupId?: number;
}

export interface GetSubcategoriesByCategoryRequest {
    categoryLookupId: number;
    isActive?: boolean;
}

export interface GetSubcategoryRequest {
    id: number;
}

export interface GetSubcategoryCountByCategoryRequest {
    categoryLookupId: number;
    isActive?: boolean;
}

export interface SearchSubcategoriesRequest {
    q: string;
    isActive?: boolean;
    categoryLookupId?: number;
}

export interface UpdateSubcategoryRequest {
    id: number;
    updateSubcategoryLookupDto: UpdateSubcategoryLookupDto;
}

export interface ValidateSubcategoryCodeRequest {
    code: string;
    excludeId?: number;
}

/**
 * 
 */
export class SubCategoryLookupServiceApi extends runtime.BaseAPI {

    /**
     * Create a new sub-category
     */
    async createSubcategoryRaw(requestParameters: CreateSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubcategoryLookupResponseDto>> {
        if (requestParameters['createSubcategoryLookupDto'] == null) {
            throw new runtime.RequiredError(
                'createSubcategoryLookupDto',
                'Required parameter "createSubcategoryLookupDto" was null or undefined when calling createSubcategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubcategoryLookupDtoToJSON(requestParameters['createSubcategoryLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubcategoryLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create a new sub-category
     */
    async createSubcategory(requestParameters: CreateSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubcategoryLookupResponseDto> {
        const response = await this.createSubcategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete a sub-category
     */
    async deleteSubcategoryRaw(requestParameters: DeleteSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSubcategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete a sub-category
     */
    async deleteSubcategory(requestParameters: DeleteSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSubcategoryRaw(requestParameters, initOverrides);
    }

    /**
     * Get all sub-categories with optional filtering
     */
    async getAllSubcategoriesRaw(requestParameters: GetAllSubcategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubcategoryLookupResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['categoryLookupId'] != null) {
            queryParameters['categoryLookupId'] = requestParameters['categoryLookupId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubcategoryLookupResponseDtoFromJSON));
    }

    /**
     * Get all sub-categories with optional filtering
     */
    async getAllSubcategories(requestParameters: GetAllSubcategoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubcategoryLookupResponseDto>> {
        const response = await this.getAllSubcategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get sub-categories by parent category lookup ID
     */
    async getSubcategoriesByCategoryRaw(requestParameters: GetSubcategoriesByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubcategoryLookupResponseDto>>> {
        if (requestParameters['categoryLookupId'] == null) {
            throw new runtime.RequiredError(
                'categoryLookupId',
                'Required parameter "categoryLookupId" was null or undefined when calling getSubcategoriesByCategory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories/by-category/{categoryLookupId}`.replace(`{${"categoryLookupId"}}`, encodeURIComponent(String(requestParameters['categoryLookupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubcategoryLookupResponseDtoFromJSON));
    }

    /**
     * Get sub-categories by parent category lookup ID
     */
    async getSubcategoriesByCategory(requestParameters: GetSubcategoriesByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubcategoryLookupResponseDto>> {
        const response = await this.getSubcategoriesByCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single sub-category by ID
     */
    async getSubcategoryRaw(requestParameters: GetSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubcategoryLookupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSubcategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubcategoryLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get a single sub-category by ID
     */
    async getSubcategory(requestParameters: GetSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubcategoryLookupResponseDto> {
        const response = await this.getSubcategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get count of sub-categories by parent category
     */
    async getSubcategoryCountByCategoryRaw(requestParameters: GetSubcategoryCountByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['categoryLookupId'] == null) {
            throw new runtime.RequiredError(
                'categoryLookupId',
                'Required parameter "categoryLookupId" was null or undefined when calling getSubcategoryCountByCategory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories/count/by-category/{categoryLookupId}`.replace(`{${"categoryLookupId"}}`, encodeURIComponent(String(requestParameters['categoryLookupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get count of sub-categories by parent category
     */
    async getSubcategoryCountByCategory(requestParameters: GetSubcategoryCountByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSubcategoryCountByCategoryRaw(requestParameters, initOverrides);
    }

    /**
     * Search sub-categories with optional parent filtering
     */
    async searchSubcategoriesRaw(requestParameters: SearchSubcategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubcategoryLookupResponseDto>>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchSubcategories().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['categoryLookupId'] != null) {
            queryParameters['categoryLookupId'] = requestParameters['categoryLookupId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubcategoryLookupResponseDtoFromJSON));
    }

    /**
     * Search sub-categories with optional parent filtering
     */
    async searchSubcategories(requestParameters: SearchSubcategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubcategoryLookupResponseDto>> {
        const response = await this.searchSubcategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing sub-category
     */
    async updateSubcategoryRaw(requestParameters: UpdateSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubcategoryLookupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSubcategory().'
            );
        }

        if (requestParameters['updateSubcategoryLookupDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubcategoryLookupDto',
                'Required parameter "updateSubcategoryLookupDto" was null or undefined when calling updateSubcategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubcategoryLookupDtoToJSON(requestParameters['updateSubcategoryLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubcategoryLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update an existing sub-category
     */
    async updateSubcategory(requestParameters: UpdateSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubcategoryLookupResponseDto> {
        const response = await this.updateSubcategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate if a sub-category code is available
     */
    async validateSubcategoryCodeRaw(requestParameters: ValidateSubcategoryCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateCodeResponseDto>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling validateSubcategoryCode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['excludeId'] != null) {
            queryParameters['excludeId'] = requestParameters['excludeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subcategory-lookup/subcategories/validate-code/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Validate if a sub-category code is available
     */
    async validateSubcategoryCode(requestParameters: ValidateSubcategoryCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateCodeResponseDto> {
        const response = await this.validateSubcategoryCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
